import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'aeda-admin-sidebar-collapsed';

@Injectable({ providedIn: 'root' })
export class SidebarLayoutService {
  readonly collapsed = signal(this.readInitial());

  toggle(): void {
    const next = !this.collapsed();
    this.collapsed.set(next);
    try {
      sessionStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      // ignore private browsing / quota errors
    }
  }

  private readInitial(): boolean {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }
}
